export function getPropertyByPath<T, D = undefined>(
  obj: unknown,
  path: string,
  defaultValue?: D,
): T | D {
  if (!obj || !path) {
    return defaultValue as D;
  }

  const pathParts = path.split('.');
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let current: any = obj;

  for (const part of pathParts) {
    if (
      current === null ||
      current === undefined ||
      typeof current !== 'object'
    ) {
      return defaultValue as D;
    }
    current = current[part];
  }

  return current !== undefined ? (current as T) : (defaultValue as D);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getNestedProperty(obj: any, path: string) {
  return path.split('.').reduce((result, key) => result?.[key], obj);
}

export function today() {
  const t = new Date();
  t.setHours(0, 0, 0, 0);
  return t;
}

/**
 * Determines whether rich-text HTML (as produced by the RichTextEditor) is
 * visually empty. The Lexical editor always serializes at least one empty
 * paragraph (e.g. `<p><br></p>`), so a plain string-length/`trim` check treats
 * an untouched editor as non-empty. This strips the markup and reports empty
 * only when there is no visible text and no embedded media.
 */
export function isRichTextEmpty(html: string | null | undefined): boolean {
  if (!html) {
    return true;
  }
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const hasText = (doc.body.textContent ?? '').trim().length > 0;
  const hasMedia = doc.body.querySelector('img, table, hr') !== null;
  return !hasText && !hasMedia;
}
